import { SET_LEFTMENU_DATA } from './mutationTypes';

export default {
  state: {
    treeDataMaps: {},
  },
  mutations: {
    [SET_LEFTMENU_DATA](state, params) {
      state.treeDataMaps = arrToMap(params);
    },
  },
};

function arrToMap(arr) {
  const map = {};

  function tomap(array) {
    array.forEach((item) => {
      const temp = { ...item };
      map[item.key.split('_')[1]] = temp;
      if (temp.children && temp.children[0]) { tomap(temp.children); }
      delete temp.children;
      delete temp.scopedSlots;
    });
  }
  tomap(arr);
  return map;
}



// WEBPACK FOOTER //
// ./src/vuex/modules/leftmenu.js